var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard-form-edit"},[_c('h2',[_vm._v("Edit your form")]),_vm._v(" "),_c('div',{staticClass:"md-layout md-alignment-top-left"},[_c('div',{staticClass:"md-layout-item md-small-size-100 md-size-66 "},[_c('form-edit-form',{attrs:{"current-form":_vm.form}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72ef99d3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/DashboardFormEdit.vue
// module id = null
// module chunks = 